import { createAsyncCases } from '@core/utils/fetch/create-cases.util';
import { createSlice } from '@reduxjs/toolkit';
import { authLogin, authRegistration, smsCodeApprove, smsCodeRequest } from '../services';
import { authReducer } from './auth.reducer';
var initialState = {
    fetch_data: {
        group: '',
        fetch_name: '',
    },
    loading: false,
    status: 0,
    error: null,
    data: {
        isAuth: false,
        user_id: '',
        invalid_code: false,
        existed_email: false,
        invalid_email: false,
        existed_username: false,
        invalid_data: false,
        user_role: '',
    },
};
export var authSlice = createSlice({
    name: 'responseData',
    initialState: initialState,
    reducers: {
        authReducer: authReducer,
    },
    extraReducers: function (builder) {
        createAsyncCases(builder, authLogin, function (state, action) {
            var _a;
            console.log(action.payload);
            if (((_a = action.payload) === null || _a === void 0 ? void 0 : _a.status) === 200) {
                state.data = typeof action.payload.data === 'string' ? {} : action.payload.data;
                state.data.isAuth = true;
                state.data.user_id = action.payload.data.user_id;
            }
        });
        createAsyncCases(builder, smsCodeRequest, function (state, action) {
            console.log(action.payload);
        });
        createAsyncCases(builder, smsCodeApprove, function (state, action) {
            console.log(action.payload);
        });
        createAsyncCases(builder, authRegistration, function (state, action) {
            console.log(action.payload);
        });
    },
});
